import Color from "../../../theme/color";
import Storage from "../../storage";

/**
 * All data related to the theme settings.
 * 
 * @author Stan Hurks
 */
export default class StorageDataModelTheme {
    /**
     * The primary color for the player
     */
    public colorPrimary: Color = new Color(255, 109, 0)

    /**
     * The secondary color for the player
     */
    public colorSecondary: Color = new Color(255, 255, 255)

    /**
     * Whether the player should have a logo
     */
    public hasLogo: boolean = true

    /**
     * The logo source
     */
    public logoSrc: string = 'https://upload.wikimedia.org/wikipedia/commons/0/06/NPO_Start_logo.png'

    /**
     * The logo URL
     */
    public logoURL: string = 'https://npostart.nl'

    /**
     * When the logo should fade out
     */
    public logoFadeOutAtMs: number | null = 3000

    /**
     * The amount of ms for the fade out effect
     */
    public logoFadeOutDurationMs: number = 300

    /**
     * Whether or not to automatically hide the controls
     * when the player is idle.
     */
    public autoHideControls: boolean = true

    /**
     * Reset the data to defaults
     */
    public static reset = () => {
        const defaultInstance = new StorageDataModelTheme()

        for (const property of Object.keys(defaultInstance)) {
            const value = (defaultInstance as any)[property] as any

            // TODO: fix
            // (Storage.data.theme as any)[property] = value
        }
    }
}